<template>
<!--评论组件-->
  <div>
    <!--层主-->
    <div class="comment-user">
      <!--<el-image :src="baseUrl+item.avatar" alt="" style="height: 40px; border-radius: 20px; margin-right: 10px;" lazy></el-image>-->
      <el-avatar style="height: 3rem; width: 3rem;" class="hover" :src="baseUrl+item.avatar">{{item.userName}}</el-avatar>
      <b class="hover">{{item.userName}}</b>
      <span v-if="userId === item.userId" style="color: white; background: darkorange;  border-radius: 3px;">作者</span>
    </div>
    <div class="comment-group">
      <div class="comment-content">
        {{item.content}}
        <div class="comment-operate"><span>IP属地:{{item.address}}</span><span>{{item.createTime}}</span><span class="hover" @click="reply(item)">回复</span></div>
      </div>

      <!--同一层的回复-->
      <div v-for="(subItem) in commentChildren" :index="subItem.cmtId">
        <div class="comment-content">
          <div class="comment-user">
            <el-avatar class="hover" :src="baseUrl+subItem.avatar">{{subItem.userName}}</el-avatar>
            <b class="hover">{{subItem.userName}}</b>
            <span v-if="userId === subItem.userId" style="color: white; background: darkorange; border-radius: 3px;">作者</span>
            <span v-if="subItem.reply">回复 <b class="hover">@{{subItem.reply.userName}}</b></span>
            <!--<span>{{subItem.content}}</span>-->
          </div>
          <div style="margin-left: 50px"><span>{{subItem.content}}</span></div>
          <div class="sub-comment-operate"><span>IP属地:{{item.address}}</span><span>{{subItem.createTime}}</span><span class="hover" @click="reply(subItem)">回复</span></div>
        </div>
      </div>

      <div v-if="isLogin && showReply" style="display: flex; margin-top: 10px;">
        <el-avatar :src="avatar" style="cursor: pointer; height: 3rem; width: 3.5rem;"></el-avatar>
        <el-input v-model="content" ref="commentInput" :disabled="!commentEnable"
                  type="textarea"
                  :maxlength="1000"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 20 }"
                  :placeholder="commentEnable?'回复 @'+repliedUserNickName+':':'该文章没有开放评论'"></el-input>
        <div style="display: flex; flex-direction: column; justify-content: flex-end">
          <el-button :loading="submitLoading" type="primary" :disabled="!content || !commentEnable" @click="submit()">发布</el-button>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
import config from '@/config'
import {commentArticle} from "@/api/comment";

export default {
  name: "Comment",
  props: ['item','userId','allowComment'],
  data() {
    return {
      content: '',
      repliedUserNickName: '',
      tempCommentItem: {},
      showReply: false,
      submitLoading: false
    }
  },
  created() {
  },
  computed: {
    commentChildren: {
      get() {
        return this.item.children;
      },
      set(newVal) {
        console.log(newVal)
        this.item.children = newVal;
      }
    },
    baseUrl() {
      return process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
    },
    isLogin() {
      return this.$store.getters.name !== '';
    },
    commentEnable() {
      return this.isLogin && this.allowComment === 0;
    },
    avatar() {
      return this.$store.getters.avatar;
    },
  },
  methods: {
    reply(comment) {
      if (!this.isLogin) {
        this.$modal.msgError('该操作需要登录');
        return;
      }
      if (!this.commentEnable) {
        this.$modal.msgError('该文章评论已关闭')
        return;
      }
      // 切换显示
      if (comment.cmtId === this.tempCommentItem.cmtId) {
        this.showReply = !this.showReply;
      } else {
        this.showReply = true;
      }
      if (this.showReply) {
        this.$nextTick(() => {
          this.$refs.commentInput.focus();
        });
      }
      this.tempCommentItem = comment;
      this.repliedUserNickName = comment.userName;
    },
    // 评论输入框失焦事件
    blur() {
      // 想通过输入框失焦就自动关闭输入框，但是效果不好，所以不弄了，还是通过回复按钮显示/关闭输入框吧
    },
    // 提交评论
    submit() {
      this.submitLoading = true;
      const commentData = {
        parentId: this.tempCommentItem.cmtId,
        articleId: this.item.articleId,
        content: this.content,
        repliedUserId: this.tempCommentItem.userId
      }
      commentArticle(commentData).then(res => {
        this.$modal.msgSuccess('您的评论将在审核通过后展示');
        this.submitLoading = false;
        // 评论成功后清空评论输入框内容
        this.content = '';
        this.showReply = false;
        // 本地展示
        let children = this.item.children
        let responseData = res.data
        if (this.tempCommentItem.parentId !== 0) {
          responseData.reply = this.tempCommentItem;
        }
        children.push(responseData)
        this.commentChildren = children
      }).catch(() => {
        this.submitLoading = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.comment {
  margin: 10px 0;

  .comment-user {
    display: flex;
    align-items: center;

  }
  .comment-group {
    //margin-left: 75px;
    margin-left: 3.5rem;

    .comment-content {
      display: block;
      //min-height: 60px;
      margin-bottom: 10px;
      .comment-operate {
        color: grey;
      }
      .sub-comment-operate {
        color: grey;
        margin-left: 50px;
      }
    }
  }
}
b {
  margin-right: 15px;;
}
span {
  margin-right: 10px;
}
.hover {
  cursor: pointer;
}
.hover:hover {
  color: #1296db;
}
</style>
